import React, { useState } from "react";
import { Alert, Badge, Col, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Input } from "../../components";
import {
  bacaMasalah,
  simpanFactor,
} from "../../config/redux/action/sustainabilityAction";
import { formatAngka } from "../../utils";

const SCOPE = [
  { id: "global", name: "Global (tarif, konstanta umum)" },
  { id: "grid", name: "Grid (faktor emisi listrik)" },
  { id: "water", name: "Water (pengolahan air)" },
  { id: "packaging", name: "Packaging (kemasan)" },
  { id: "program", name: "Program (per program cuci)" },
  { id: "machine", name: "Machine (per mesin)" },
];

const TIER = [
  { id: "T1", name: "T1" },
  { id: "T2", name: "T2" },
  { id: "T3", name: "T3" },
  { id: "T4", name: "T4" },
];

const kosong = {
  scope: "global",
  key: "",
  nilai: "",
  unit: "",
  quality_tier: "T3",
  sumber: "",
  ref_id: "",
  effective_from: new Date().toISOString().slice(0, 10),
};

function TabFactor({ list, update }) {
  const [Show, setShow] = useState(false);
  const [Form, setForm] = useState(kosong);
  const [Error, setError] = useState([]);
  const dispatch = useDispatch();

  const ubah = (key, value) => setForm({ ...Form, [key]: value });

  const buka = (sumberBaris) => {
    setError([]);
    // Menambah versi baru dari baris yang ada jauh lebih sering terjadi daripada
    // membuat faktor baru, jadi form diisi awal dari baris yang dipilih.
    setForm(
      sumberBaris
        ? {
            scope: sumberBaris.scope,
            key: sumberBaris.key,
            nilai: sumberBaris.nilai ?? "",
            unit: sumberBaris.unit || "",
            quality_tier: sumberBaris.quality_tier || "T3",
            sumber: sumberBaris.sumber || "",
            ref_id: sumberBaris.ref_id ?? "",
            effective_from: new Date().toISOString().slice(0, 10),
          }
        : kosong
    );
    setShow(true);
  };

  const simpan = () => {
    setError([]);
    dispatch(
      simpanFactor({
        scope: Form.scope,
        key: Form.key,
        nilai: Form.nilai === "" ? undefined : Number(Form.nilai),
        unit: Form.unit,
        quality_tier: Form.quality_tier,
        sumber: Form.sumber,
        ref_id: Form.ref_id === "" ? null : Number(Form.ref_id),
        effective_from: Form.effective_from || undefined,
      })
    )
      .then(() => {
        update();
        setShow(false);
      })
      .catch((err) => setError(bacaMasalah(err)));
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="text-muted" style={{ fontSize: "11px" }}>
          Faktor tidak pernah ditimpa. Menyimpan berarti membuat versi baru dan
          mengarsipkan versi aktif sebelumnya untuk scope, key, dan ref yang sama.
        </div>
        <button className="btn btn-sm btn-primary" onClick={() => buka(null)}>
          Tambah Faktor
        </button>
      </div>

      <div className="table-responsive">
        <table
          className="table table-bordered align-middle mb-0"
          style={{ fontSize: "12px" }}
        >
          <thead className="table-light">
            <tr>
              <th>Scope</th>
              <th>Key</th>
              <th className="text-end">Ref ID</th>
              <th className="text-end">Nilai</th>
              <th>Unit</th>
              <th className="text-center">Tier</th>
              <th>Sumber</th>
              <th>Berlaku Sejak</th>
              <th className="text-center">Versi</th>
              <th className="text-center">Status</th>
              <th className="text-center">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {list && list.length > 0 ? (
              list.map((val) => (
                <tr key={val.id}>
                  <td>{val.scope}</td>
                  <td className="fw-bold">{val.key}</td>
                  <td className="text-end">{val.ref_id ?? "-"}</td>
                  <td className="text-end">{formatAngka(val.nilai, 6)}</td>
                  <td>{val.unit}</td>
                  <td className="text-center">
                    <Badge bg="secondary">{val.quality_tier}</Badge>
                  </td>
                  <td className="ws-preline">{val.sumber || "-"}</td>
                  <td>
                    {val.effective_from
                      ? moment(val.effective_from).format("DD MMM YYYY")
                      : "-"}
                  </td>
                  <td className="text-center">v{val.version}</td>
                  <td className="text-center">
                    <Badge bg={val.status === "active" ? "success" : "dark"}>
                      {val.status}
                    </Badge>
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      style={{ fontSize: "10px" }}
                      onClick={() => buka(val)}
                    >
                      Versi Baru
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} align="center">
                  Data tidak ditemukan
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal show={Show} onHide={() => setShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "16px" }}>
            Versi Faktor Baru
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Error.length > 0 && (
            <Alert variant="danger" style={{ fontSize: "12px" }}>
              <ul className="mb-0 ps-3">
                {Error.map((val, i) => (
                  <li key={i}>{val}</li>
                ))}
              </ul>
            </Alert>
          )}

          <Row>
            <Col xs={12} lg={6}>
              <Input
                judul="Scope *"
                type="select"
                data={SCOPE}
                value={Form.scope}
                onChange={(e) => ubah("scope", e.target.value)}
              />
              <Input
                judul="Key *"
                type="text"
                placeholder="harga_air_per_liter, grid_emission_factor"
                value={Form.key}
                onChange={(e) => ubah("key", e.target.value)}
              />
              <Input
                judul="Ref ID (untuk scope program / machine)"
                type="number"
                value={Form.ref_id}
                onChange={(e) => ubah("ref_id", e.target.value)}
              />
              <Input
                judul="Berlaku Sejak"
                type="date"
                value={Form.effective_from}
                onChange={(e) => ubah("effective_from", e.target.value)}
              />
            </Col>
            <Col xs={12} lg={6}>
              <Input
                judul="Nilai *"
                type="number"
                value={Form.nilai}
                onChange={(e) => ubah("nilai", e.target.value)}
              />
              <Input
                judul="Unit *"
                type="text"
                placeholder="rupiah/liter, kgCO2e/kWh"
                value={Form.unit}
                onChange={(e) => ubah("unit", e.target.value)}
              />
              <Input
                judul="Quality Tier *"
                type="select"
                data={TIER}
                value={Form.quality_tier}
                onChange={(e) => ubah("quality_tier", e.target.value)}
              />
              <Input
                judul="Sumber *"
                type="textarea"
                placeholder="Referensi tarif atau publikasi faktor"
                value={Form.sumber}
                onChange={(e) => ubah("sumber", e.target.value)}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-sm btn-secondary me-2"
              onClick={() => setShow(false)}
            >
              Batal
            </button>
            <button className="btn btn-sm btn-primary" onClick={simpan}>
              Simpan Versi Baru
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default TabFactor;
